import './Hero.css';

const SLIDES = [
  {
    image: `${process.env.PUBLIC_URL}/assets/img/01.png`,
    subtitle: 'Transporte e Logística',
    title: (
      <>
        Soluções <span className="text-accent">logísticas</span> para todo o Brasil
      </>
    ),
    description:
      'Referência no mercado nacional para transporte de cargas lotação, com agilidade, excelência e compromisso em cada entrega.',
  },
  {
    image: `${process.env.PUBLIC_URL}/assets/img/04.png`,
    subtitle: 'Infraestrutura e Armazenagem',
    title: (
      <>
        Hub logístico em <span className="text-accent">Curitiba — PR</span>
      </>
    ),
    description:
      'Centro de armazenagem com segurança, controle e estrutura para complementar sua operação logística.',
  },
  {
    image: `${process.env.PUBLIC_URL}/assets/img/02.png`,
    subtitle: 'Cobertura Nacional',
    title: (
      <>
        Atuação em <span className="text-accent">100% do território</span> brasileiro
      </>
    ),
    description:
      'Rotas estratégicas e operação dedicada para conectar sua empresa a qualquer destino no país.',
  },
  {
    image: `${process.env.PUBLIC_URL}/assets/img/03.png`,
    subtitle: 'Infraestrutura e Armazenagem',
    title: (
      <>
        Frota especializada para <span className="text-accent">suas necessidades</span>
      </>
    ),
    description:
      'Veículos modernos, tecnologias avançadas e profissionais capacitados para garantir eficiência e segurança em cada viagem.',
  },
];

function Hero() {
  return (
    <section id="inicio" className="hero-section" aria-label="Destaques">
      <div
        id="heroCarousel"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
        data-bs-interval="6000"
      >
        <div className="carousel-indicators">
          {SLIDES.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide-to={index}
              className={index === 0 ? 'active' : ''}
              aria-current={index === 0 ? 'true' : undefined}
              aria-label={`Slide ${index + 1}`}
            />
          ))}
        </div>

        <div className="carousel-inner">
          {SLIDES.map((slide, index) => {
            const alignSide = index % 2 === 0 ? 'start' : 'end';

            return (
              <div
                key={index}
                className={`carousel-item hero-slide-${alignSide} ${index === 0 ? 'active' : ''}`}
              >
                <img
                  src={slide.image}
                  className="hero-bg"
                  alt=""
                  loading={index === 0 ? 'eager' : 'lazy'}
                  fetchpriority={index === 0 ? 'high' : 'auto'}
                />
                <div className="hero-overlay" />
                <div className={`carousel-caption hero-caption hero-caption-${alignSide}`}>
                  <p className="hero-subtitle">{slide.subtitle}</p>
                  <h1 className="hero-title">{slide.title}</h1>
                  <div className="red-divider" />
                  <p className="hero-description">{slide.description}</p>
                  <div className="hero-actions">
                    <a href="#servicos" className="btn btn-primary-custom">
                      Nossos Serviços
                    </a>
                    <a href="#contato" className="btn btn-outline-custom ms-2 mt-2 mt-sm-0">
                      Fale Conosco
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="prev"
          aria-label="Slide anterior"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="next"
          aria-label="Próximo slide"
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
        </button>
      </div>
    </section>
  );
}

export default Hero;
